/**
 * 应用入口
 *
 * 启动顺序：
 * 1. 导入全局样式 + 两套主题 CSS（通过 data-theme 属性切换生效）
 * 2. 创建 Vue 应用实例，注册 Pinia、Router、Naive UI
 * 3. 初始化主题（恢复用户偏好并写入 <html> data-theme 属性）
 * 4. 恢复登录会话
 * 5. 挂载到 DOM
 */
import './assets/main.css'
import './theme/dark/index.css'
import './theme/light/index.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import naive from 'naive-ui'

import App from './App.vue'
import router from './router'
import { useAuthStore } from '@/features/auth'
import { useThemeStore } from '@/store/theme'
import { installTouchZoomGuards } from '@/platform/touch/installTouchZoomGuards'
import { installPlainTextInputGuards } from '@/utils/plainTextInput'

const app = createApp(App)
const pinia = createPinia()
document.title = '橙易'

function showStartupError(error: unknown) {
  void error
  const root = document.querySelector<HTMLElement>('#app')
  if (!root) return
  root.innerHTML = [
    '<div style="padding:16px;font-size:14px;line-height:1.7;color:#222;background:#fff;">',
    '<h2 style="margin:0 0 8px;font-size:18px;">浏览器兼容性异常</h2>',
    '<p style="margin:0 0 8px;">当前浏览器无法启动制作工具，建议使用 Chrome 或 Edge 打开。</p>',
    '<p style="margin:0;color:#666;">如果必须使用当前浏览器，请升级浏览器内核后重试。</p>',
    '</div>',
  ].join('')
}

async function bootstrap(): Promise<void> {
  installTouchZoomGuards()
  installPlainTextInputGuards()
  app.use(pinia)
  app.use(router)
  app.use(naive)
  useThemeStore(pinia).init()
  await useAuthStore(pinia).restore()
  app.mount('#app')
}

bootstrap().catch((error: unknown) => {
  showStartupError(error)
})
